export default __webpack_public_path__ + "static/media/top-left-ellipse.421a590c.svg";